import {daysBetween, addDaysToDate} from '../math'
import {
  LBS_TO_TONNES,
  BARLEY_COST_FROM_TONNE_TO_BUSHEL,
  BARLEY_COST_PER_BUSHEL_TO_SILAGE,
} from '../../constants'
import {feedValuesClosestToDate} from './sharedCalculations'
import moment from 'moment'

export const projectionFinishedDateAsString = (defaults, projection) => {
  if (defaults.finishedDate !== null) {
    return defaults.finishedDate
  }

  return moment(projectionFinishedDate(defaults, projection)).format(
    'YYYY-MM-DD',
  )
}

export const projectionFinishedDate = (defaults, projection) => {
  return addDaysToDate(
    projection.saleDate,
    projectionDaysOnFeed(defaults, projection),
  )
}

export const projectionFeedlotCostOfGain = (defaults, projection) => {
  const daysOnFeed = projectionDaysOnFeed(defaults, projection)

  const {
    barley,
    beddingPerHead,
    deathLossPerHead,
    interestPerHead,
    marketingPerHead,
    outWeight,
    silage,
    supplement,
    supplementCost,
    truckingInPerHead,
    vetAndMedPerHead,
    yardagePerDay,
  } = defaults

  const barleyCost = projection.costOfBarley

  return (
    (Number(daysOnFeed) * Number(barley) / LBS_TO_TONNES * Number(barleyCost) +
      Number(daysOnFeed) *
        Number(barleyCost) /
        BARLEY_COST_FROM_TONNE_TO_BUSHEL *
        BARLEY_COST_PER_BUSHEL_TO_SILAGE *
        Number(silage) /
        LBS_TO_TONNES +
      Number(daysOnFeed) *
        Number(supplement) /
        LBS_TO_TONNES *
        Number(supplementCost) +
      Number(truckingInPerHead) +
      Number(marketingPerHead) +
      Number(yardagePerDay) * Number(daysOnFeed) +
      Number(vetAndMedPerHead) +
      Number(deathLossPerHead) +
      Number(beddingPerHead) +
      Number(interestPerHead)) /
    (Number(outWeight) - Number(projection.sellingWeight))
  )
}

export const projectionMarketPrice = (
  defaults,
  projection,
  dtnFeedData,
  basisValues,
) => {
  const finishedDate = projectionFinishedDate(defaults, projection)
  const {liveCattle, cdn, basisValue} = feedValuesClosestToDate(
    finishedDate,
    dtnFeedData,
    basisValues,
  )
  const feedlotCostOfGain = projectionFeedlotCostOfGain(defaults, projection)

  return (
    ((Number(liveCattle.lastValue) / Number(cdn.lastValue) +
      Number(basisValue.val)) *
      (Number(defaults.outWeight) / 100) -
      (Number(defaults.outWeight) - Number(projection.sellingWeight)) *
        Number(feedlotCostOfGain)) /
    Number(projection.sellingWeight)
  )
}

export const projectionGrossCostPerHead = (
  defaults,
  projection,
  dtnFeedData,
  basisValues,
) => {
  const projectedMarketPrice = projectionMarketPrice(
    defaults,
    projection,
    dtnFeedData,
    basisValues,
  )
  return Number(projectedMarketPrice) * Number(projection.sellingWeight)
}

const projectionDaysOnFeed = (defaults, projection) => {
  // User entered default
  if (defaults.finishedDate !== null) {
    return daysBetween(defaults.finishedDate, projection.saleDate)
  } else {
    return Math.floor(
      (Number(defaults.outWeight) - Number(projection.sellingWeight)) /
        Number(defaults.avgDailyGain),
    )
  }
}



// WEBPACK FOOTER //
// ./src/helpers/calculators/projectionCalculations.js